const LANDING_EN = Object.freeze({
  'landing.title': 'Log in to\nyour Qupital\naccount',
  'landing.subtitle': 'Welcome back! Please log in to your account',

  'landing.referral.title.lian_lian_pay': 'LianLian Pay Customer',
  'landing.referral.subtitle.lian_lian_pay': 'Welcome to Qiao Yi Dai service',

  'landing.referral.title.winit_corporation': 'Winit Customer',
  'landing.referral.subtitle.winit_corporation': 'Welcome to Qiao Yi Dai service',
});

export { LANDING_EN };
